import { Title } from '@solidjs/meta'
import { useParams } from '@solidjs/router'
import { type Component, createEffect, createResource, onCleanup, Show } from 'solid-js'
import Card from '~/components/Card'
import GoBack from '~/components/GoBack'
import Skeleton from '~/components/Skeleton'
import QuoteForm from '~/layers/ui/admin/cotizaciones/QuoteForm'

import { quoteService } from '~/services/quote.service'
import { setTrailOverride } from '~/stores/breadcrumb'

/**
 * Ficha de una cotización existente (/admin/cotizaciones/:id). Comparte el
 * formulario con la creación; sólo cambia qué recurso se carga.
 */
const CotizacionPage: Component = () => {
  const params = useParams()
  const [quote] = createResource(
    () => Number(params.id),
    async (id: number) => {
      try {
        return await quoteService.get(id)
      } catch {
        return null
      }
    }
  )

  // Miga de pan propia: "Cotizaciones › [número]". Se limpia al salir.
  createEffect(() => {
    const number = quote()?.number
    setTrailOverride(['Cotizaciones', number || 'Editar Cotización'])
  })
  onCleanup(() => setTrailOverride(null))

  return (
    <>
      <Title>Editar Cotización | Florez Jaramillo</Title>

      <Show
        when={!quote.loading}
        fallback={
          <Card>
            <Card.Body>
              <div class="space-y-3">
                <Skeleton height="2rem" width="40%" />
                <Skeleton height="1rem" width="70%" />
                <Skeleton height="12rem" />
              </div>
            </Card.Body>
          </Card>
        }
      >
        <Show
          when={quote()}
          fallback={
            <Card>
              <Card.Body>
                <div class="text-center py-10 space-y-4">
                  <p class="text-foreground-subtle">No pudimos cargar esta cotización. Puede que ya no exista.</p>
                  <GoBack label="Volver a cotizaciones" fallbackPath="/admin/cotizaciones" />
                </div>
              </Card.Body>
            </Card>
          }
        >
          {data => <QuoteForm quote={data} />}
        </Show>
      </Show>
    </>
  )
}

export default CotizacionPage
